"use strict"; 
import { TABLE_CELL_MARKER_UTILITIES } from "../util/classes";
import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { jsDebug } from "../util/classes";
import { UTL } from "../util/classes";
import { TRANS } from "../util/classes";
import { TABLE, TableObject, TBLSCROLLER, TABLE_Location } from "../util/classes";
import { TABLE_SORT_ROWS_AUX_FUNCTIONS } from "../util/classes";
import { TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS } from "../util/classes";
import { DOM_AUX_FUNCTIONS } from "../util/classes";
import { Elcon } from "../util/classes";
import { DLG } from "../util/classes";
import { GSP } from "../util/classes";
import { CMP } from "../util/cmp";
import { SMART_CMP } from "../util/smart_cmp";
import { Whisper } from "../util/classes";
import { VECTOR, VECTOR_Task, VECTOR_Capsule, VECTOR_Info } from "../util/classes";
import { CdFnCntPayload } from "../util/classes";
import { COMM_LOGIC_TYPE } from "../util/classes";
import { DIALOG500 } from "../util/dialog500";
import { cmux_refresh_site } from "../apps/cmux_general";
import { NotifyPlus, NotifyPlusStyleRecord, NotifyPlusAuxFunctions } from "../util/popupPlus_Notify"; // <--- ייבוא הפונקציה הספציפית
import { FacadePlus } from "../util/popupPlus_Facade";

declare var working_org_code: string; // cshtml המשתנה הזה מוגדר בקובץ


enum CMU_Bus105_FID {
    ROW_NUM,
    RECORD_CODE,
    REC_ORG_CODE,
    REC_USERNAME,
    REC_PASSWORD,
    REC_FIRSTNAME,
    REC_LASTNAME,
    REC_TAARIH_HITSTARFUT,
    REC_UNIVERSAL_NAME_HE,
    REC_UNIVERSAL_NAME_EN,
    REC_UNIVERSAL_NAME_RU,
    REC_ADDRESS,
    REC_PHONE_NUMBER,
    REC_EMAIL,
    REC_IS_ACTIVE,
    REC_REMARK,
    IFB_RELOAD_RECORD
}

interface CMU_Bus105_REC {
    NUMKEY_as_str: string;
    REC_ORG_CODE_as_str: string;
    REC_USERNAME_as_str: string;
    REC_PASSWORD_as_str: string;
    REC_FIRSTNAME_as_str: string;
    REC_LASTNAME_as_str: string;
    REC_TAARIH_HITSTARFUT_as_str: string;
    REC_UNIVERSAL_NAME_HE_as_str: string;
    REC_UNIVERSAL_NAME_EN_as_str: string;
    REC_UNIVERSAL_NAME_RU_as_str: string;
    REC_ADDRESS_as_str: string;
    REC_PHONE_NUMBER_as_str: string;
    REC_EMAIL_as_str: string;
    REC_IS_ACTIVE_as_str: string;
    REC_REMARK_as_str: string;
    IFB_RELOAD_RECORD_as_str: string; // שומרים על עקביות למרות שלא ב-Dictionary כרגע
}



export class CMU_Bus105 {
    public static CMU_Bus105_vector_update_function(vector_capsule: VECTOR_Capsule): void {
        UTL.GENERAL_VECTOR_UPDATE_FUNCTION(vector_capsule);
    }

    public static CMU_Bus105_VAR_CURRENT_ROW = 0;
    public static CMU_Bus105_VAR_CURRENT_COLUMN = 0;
    public static CMU_Bus105_trans_fid_string_to_fid_enum(fid: string): CMU_Bus105_FID {
        if (fid == "ROW_NUM") return CMU_Bus105_FID.ROW_NUM;
        if (fid == "RECORD_CODE") return CMU_Bus105_FID.RECORD_CODE;
        if (fid == "REC_ORG_CODE") return CMU_Bus105_FID.REC_ORG_CODE;
        if (fid == "REC_USERNAME") return CMU_Bus105_FID.REC_USERNAME;
        if (fid == "REC_PASSWORD") return CMU_Bus105_FID.REC_PASSWORD;
        if (fid == "REC_FIRSTNAME") return CMU_Bus105_FID.REC_FIRSTNAME;
        if (fid == "REC_LASTNAME") return CMU_Bus105_FID.REC_LASTNAME;
        if (fid == "REC_TAARIH_HITSTARFUT") return CMU_Bus105_FID.REC_TAARIH_HITSTARFUT;
        if (fid == "REC_UNIVERSAL_NAME_HE") return CMU_Bus105_FID.REC_UNIVERSAL_NAME_HE;
        if (fid == "REC_UNIVERSAL_NAME_EN") return CMU_Bus105_FID.REC_UNIVERSAL_NAME_EN;
        if (fid == "REC_UNIVERSAL_NAME_RU") return CMU_Bus105_FID.REC_UNIVERSAL_NAME_RU;
        if (fid == "REC_ADDRESS") return CMU_Bus105_FID.REC_ADDRESS;
        if (fid == "REC_PHONE_NUMBER") return CMU_Bus105_FID.REC_PHONE_NUMBER;
        if (fid == "REC_EMAIL") return CMU_Bus105_FID.REC_EMAIL;
        if (fid == "REC_IS_ACTIVE") return CMU_Bus105_FID.REC_IS_ACTIVE;
        if (fid == "REC_REMARK") return CMU_Bus105_FID.REC_REMARK;
        if (fid == "IFB_RELOAD_RECORD") return CMU_Bus105_FID.IFB_RELOAD_RECORD;
        alert(`CMU_Bus105_trans_fid_string_to_fid_enum(). error: unknown fid. fid=${fid}`);
        throw new Error(`CMU_Bus105_slow_trans_fid_to_column_number(). error: unknown fid. fid=${fid}`);
    }

    public static CMU_Bus105_get_header_row_element(): HTMLTableRowElement {

        const table_obj: TableObject = CMU_Bus105.CMU_Bus105_create_table_object();
        const th_element: HTMLTableSectionElement = table_obj.table_element.tHead;
        const row_element = th_element.rows[0]
        return row_element;
    }

    public static CMU_Bus105_trans_column_index_to_fid_as_str(column_index: number): string {
        const tr_element: HTMLTableRowElement = CMU_Bus105.CMU_Bus105_get_header_row_element();
        const th_element: HTMLTableCellElement = tr_element.cells[column_index];
        const fid_string: string = th_element.dataset.fid;
        return fid_string;
    }


    public static CMU_Bus105_trans_column_number_to_fid(column_index: number): CMU_Bus105_FID {
        const fid_as_str = CMU_Bus105.CMU_Bus105_trans_column_index_to_fid_as_str(/*CMU_Bus105_VAR_CURRENT_COLUMN*/column_index);
        const fid_as_enum: CMU_Bus105_FID = CMU_Bus105.CMU_Bus105_trans_fid_string_to_fid_enum(fid_as_str);
        return fid_as_enum;
    }


    public static CMU_Bus105_trans_fid_to_string(fid: CMU_Bus105_FID) {
        // this is the way to translate in TYPE SCRIPT an ENUM to STRING
        const str: string = CMU_Bus105_FID[fid];
        return str;
    }

    public static CMU_Bus105_slow_trans_fid_to_column_number(fid: CMU_Bus105_FID): number {

        const fid_str = CMU_Bus105.CMU_Bus105_trans_fid_to_string(fid);
        const tr_element: HTMLTableRowElement = CMU_Bus105.CMU_Bus105_get_header_row_element();
        for (let i = 0; i < tr_element.cells.length; i++) {
            const th_element: HTMLTableCellElement = tr_element.cells[i];
            //alert(`loop: th_element.dataset.fid=${th_element.dataset.fid}`);
            if (th_element.dataset.fid == fid_str) {
                return i;
            }
        }
        alert(`CMU_Bus105_slow_trans_fid_to_column_number(). error: unknown fid. fid=${fid}`);
        throw new Error(`CMU_Bus105_slow_trans_fid_to_column_number(). error: unknown fid. fid=${fid}`);
    }

    public static CMU_Bus105_get_NofColumns(): number {
        const header_row_element: HTMLTableRowElement = CMU_Bus105.CMU_Bus105_get_header_row_element();
        const NofColumns: number = header_row_element.cells.length;
        return NofColumns;
    }

    
    public static async CMU_Bus105_COM_GetRecord(record_code: number): Promise<CMU_Bus105_REC> {
        debugger;
        if (record_code == (-1)) {
            alert("load_record().record_code==(-1)");
            return;
        }
        const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
        fetch_options.method = 'GET';
        const url = `/cmux/cmux_bus105?handler=GetRecord&record_code=${record_code}`;

        const response: Response = await fetch(url, fetch_options);
        const REC = await response.json();
        return REC
    }

    public static async CMU_Bus105_reload_record_and_populate(row_number: number): Promise<void> {
        const record_code = CMU_Bus105.CMU_Bus105_trans_row_number_to_record_code(row_number);
        const REC = await CMU_Bus105.CMU_Bus105_COM_GetRecord(record_code);
        CMU_Bus105.CMU_Bus105_POPULATE_ROW(row_number, REC);
    }


    public static async CMU_Bus105_respond_button_reload_record(record_code: number): Promise<void> {
        const row_number = CMU_Bus105.CMU_Bus105_trans_reocrd_code_to_row_number(record_code);
        //const promise = CMU_Bus105_GetRecord(record_code);
        //const REC = await promise;
        //CMU_Bus105_POPULATE_ROW(row_number, REC);
        CMU_Bus105.CMU_Bus105_reload_record_and_populate(row_number);
    }



    public static async CMU_Bus105_respond_button_edit_record(record_code: number): Promise<void> {
        alert("לא ניתן לבצע הזנה בצורה");
    }



    public static CMU_Bus105_SMOOTH_SCROLL_TO_LAST_LINE(): void {
        alert("CMU_Bus105_SMOOTH_SCROLL_TO_LAST_LINE().maybe this public static to be obsolete")
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        const last_row_element = TABLE.get_last_row_element_of_table(table_obj.table_element);
        last_row_element.scrollIntoView({ behavior: "smooth" });
    }



    public static CMU_Bus105_fill_status_element(text: string, color_str: string, background_color_str: string) {
        const status_element = document.getElementById("id-main-window-status-line");
        status_element.textContent = text;
        status_element.style.color = color_str;
        status_element.style.backgroundColor = background_color_str;
    }












    public static CMU_Bus105_trans_row_number_to_record_code(row_number: number): number {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        const row_element = TABLE.trans_table_element_and_row_number_to_row_element(table_obj.table_element, row_number)
        const id_str = row_element.id;
        const record_code = UTL.extract_last_number_from_string_as_number(id_str);
        return record_code;
    }


    public static CMU_Bus105_perform_F3(): void {
        const record_code = CMU_Bus105.CMU_Bus105_trans_row_number_to_record_code(CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW);
        CMU_Bus105.CMU_Bus105_respond_button_edit_record(record_code);
    }



    public static CMU_Bus105_trans_record_code_to_id_of_row(record_code: number): string {
        const id_str = `id-row-code-${record_code}`
        return id_str
    }

    public static CMU_Bus105_slow_trans_reocrd_code_to_row_number(record_code: number): number {
        // בגלל שהיא מבצעת לולאה על כל השורות slow פונקציה זו היא מסוג
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        const n_of_rows = TABLE.get_number_of_rows_in_table(table_obj.table_element);
        const column_number: number = CMU_Bus105.CMU_Bus105_slow_trans_fid_to_column_number(CMU_Bus105_FID.RECORD_CODE);
        for (let row_number = 0; row_number < n_of_rows; row_number++) {
            const row_element = TABLE.trans_table_element_and_row_number_to_row_element(table_obj.table_element, row_number);
            const lp_record_code = UTL.extract_last_number_from_string_as_number(row_element.id);
            //alert(`record_code=${record_code}`)
            //if (cell_element.textContent == record_code) {
            //    return row_number;
            //}
            if (lp_record_code == record_code) {
                return row_number;
            }
        }
        return (-1);
    }


    public static CMU_Bus105_quick_trans_reocrd_code_to_row_number(record_code: number): number {
        const id_str: string = CMU_Bus105.CMU_Bus105_trans_record_code_to_id_of_row(record_code);
        const row_element_as_HTMLElement: HTMLElement = document.getElementById(id_str);
        if (row_element_as_HTMLElement == null) {
            alert("row_element_as_HTMLElement == null");
            return (-1);
        }
        if ((row_element_as_HTMLElement instanceof HTMLTableRowElement) == false) {
            alert("row_element_as_HTMLElement is not HTMLTableRowElement");
            return (-1);
        }
        const row_element_as_HTMLTableRowElement: HTMLTableRowElement = row_element_as_HTMLElement as HTMLTableRowElement;
        if (row_element_as_HTMLTableRowElement == null) {
            alert("row_element == null (z)");
            return (-1);
        }
        const row_number: number = TABLE.trans_row_element_to_row_number(row_element_as_HTMLTableRowElement);
        return row_number;
    }

    public static CMU_Bus105_trans_reocrd_code_to_row_number(record_code: number): number {
        const quick_row_number = CMU_Bus105.CMU_Bus105_quick_trans_reocrd_code_to_row_number(record_code);
        const slow_row_number = CMU_Bus105.CMU_Bus105_slow_trans_reocrd_code_to_row_number(record_code);
        if (quick_row_number != slow_row_number) {
            alert("internal error: slow_row_number != quick_row_number");
            return (-1);
        }
        return quick_row_number;
    }


    public static CMU_Bus105_GET_CELL_ELEMENT_V1(row_number: number, column_number: number): HTMLTableCellElement {
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        const cell_element: HTMLTableCellElement = TABLE.trans_table_element_and_row_number_and_column_number_to_cell_element(table_obj.table_element, row_number, column_number);
        return cell_element;
    }

    public static CMU_Bus105_GET_CELL_ELEMENT_V2(row_number: number, fid: number): HTMLTableCellElement {
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        const column_number: number = CMU_Bus105.CMU_Bus105_slow_trans_fid_to_column_number(fid);
        return CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V1(row_number, column_number);
    }

    public static CMU_Bus105_GET_CELL_ELEMENT_V3(record_code: number, column_number: number): HTMLTableCellElement {
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        const row_number = CMU_Bus105.CMU_Bus105_trans_reocrd_code_to_row_number(record_code);
        return CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V1(row_number, column_number);
    }

    public static CMU_Bus105_GET_CELL_ELEMENT_V4(record_code: number, fid: number): HTMLTableCellElement {
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        // להזכירך: פונקציה זאת תפקידה להביא   את האלמנט עצמו ולא את התוכן שבתוכו
        const row_number = CMU_Bus105.CMU_Bus105_trans_reocrd_code_to_row_number(record_code);
        const column_number: number = CMU_Bus105.CMU_Bus105_slow_trans_fid_to_column_number(fid);
        return CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V1(row_number, column_number);
    }


    public static CMU_Bus105_GET_CELL_CONTENT_V1(row_number: number, column_number: number, elcon: Elcon): string {
        const cell_element = CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V1(row_number, column_number);
        return UTL.get_content_of_element_given_elcon(cell_element, elcon);
    }

    public static CMU_Bus105_GET_CELL_CONTENT_V2(row_number: number, fid: number, elcon: Elcon): string {
        const cell_element = CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V2(row_number,fid);
        return UTL.get_content_of_element_given_elcon(cell_element, elcon);
    }

    public static CMU_Bus105_GET_CELL_CONTENT_V3(record_code: number, column_number: number, elcon: Elcon): string {
        const cell_element = CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V3(record_code, column_number);
        return UTL.get_content_of_element_given_elcon(cell_element, elcon);
    }

    public static CMU_Bus105_GET_CELL_CONTENT_V4(record_code: number, fid: number, elcon: Elcon): string {
        const cell_element = CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V4(record_code, fid);
        return UTL.get_content_of_element_given_elcon(cell_element, elcon);
    }


    public static CMU_Bus105_PUT_CELL_CONTENT_V1(row_number: number, column_number: number, elcon: Elcon, new_content_str: string): void {
        const cell_element = CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V1(row_number, column_number);
        UTL.put_content_in_element_given_elcon(cell_element, elcon, new_content_str);
    }

    public static CMU_Bus105_PUT_CELL_CONTENT_V2(row_number: number, fid: number, elcon: Elcon, new_content_str: string): void {
        const cell_element = CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V2(row_number, fid);
        UTL.put_content_in_element_given_elcon(cell_element, elcon, new_content_str);
    }

    public static CMU_Bus105_PUT_CELL_CONTENT_V3(record_code: number, column_number: number, elcon: Elcon, new_content_str: string): void {
        const cell_element = CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V3(record_code, column_number);
        UTL.put_content_in_element_given_elcon(cell_element, elcon, new_content_str);
    }


    public static CMU_Bus105_PUT_CELL_CONTENT_V4(record_code: number, fid: number, elcon: Elcon, new_content_str: string): void {
        const cell_element = CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V4(record_code, fid);
        UTL.put_content_in_element_given_elcon(cell_element, elcon, new_content_str);
    }



    public static CMU_Bus105_POPULATE_ROW(row_number: number, REC: CMU_Bus105_REC): void { // XX
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.RECORD_CODE, Elcon.textContent, REC.NUMKEY_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_ORG_CODE, Elcon.textContent, REC.REC_ORG_CODE_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_USERNAME, Elcon.textContent, REC.REC_USERNAME_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_PASSWORD, Elcon.textContent, REC.REC_PASSWORD_as_str);

        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_FIRSTNAME, Elcon.textContent, REC.REC_FIRSTNAME_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_LASTNAME, Elcon.textContent, REC.REC_LASTNAME_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_TAARIH_HITSTARFUT, Elcon.textContent, REC.REC_TAARIH_HITSTARFUT_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_UNIVERSAL_NAME_HE, Elcon.textContent, REC.REC_UNIVERSAL_NAME_HE_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_UNIVERSAL_NAME_EN, Elcon.textContent, REC.REC_UNIVERSAL_NAME_EN_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_UNIVERSAL_NAME_RU, Elcon.textContent, REC.REC_UNIVERSAL_NAME_RU_as_str);




        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_ADDRESS, Elcon.textContent, REC.REC_ADDRESS_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_PHONE_NUMBER, Elcon.textContent, REC.REC_PHONE_NUMBER_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_EMAIL, Elcon.textContent, REC.REC_EMAIL_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_IS_ACTIVE, Elcon.textContent, REC.REC_IS_ACTIVE_as_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(row_number, CMU_Bus105_FID.REC_REMARK, Elcon.textContent, REC.REC_REMARK_as_str);
    }

    public static async CMU_Bus105_COM_CreateNewRecord(): Promise<CMU_Bus105_REC> {
        debugger;
        FacadePlus.Append_V2_F6();
        const token = UTL.ASP_GetAntiForgeryToken();
        const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
        fetch_options.method = "POST";
        fetch_options.headers = { 'RequestVerificationToken': token };
        fetch_options.cache = "no-store";
        const org_code_str = working_org_code;
        const url = `/cmux/cmux_bus105?handler=CreateNewRecord&org_code=${org_code_str}`;
        const response: Response = await fetch(url, fetch_options);
        const REC = await response.json();
        await UTL.sleep_async(500);
        NotifyPlus.Close();
        return REC;
    }

    public static async CMU_Bus105_PERFORM_APPEND_RECORD(): Promise<void> {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        const freezed_number_of_rows = TABLE.trans_table_element_to_number_of_rows(table_obj.table_element);
        const freezed_last_row_num = freezed_number_of_rows;
        const REC = await CMU_Bus105.CMU_Bus105_COM_CreateNewRecord();
        //------------------------------------------------------------------------------------------
        const record_code_as_str = REC.NUMKEY_as_str;
        const record_code = parseInt(record_code_as_str, 10);
        const NofColumns = CMU_Bus105.CMU_Bus105_get_NofColumns();
        const row_id_str = CMU_Bus105.CMU_Bus105_trans_record_code_to_id_of_row(record_code);
        //------------------------------------------------------------------------------------------
        TABLE.ADD_EMPTY_ROW_WITH_EMPTY_CELLS_AT_END_OF_TABLE(table_obj.table_element, NofColumns);
        //------------------------------------------------------------------------------------------
        const last_row_number = TABLE.get_last_row_number_of_table(table_obj.table_element);
        const last_row_element = TABLE.get_last_row_element_of_table(table_obj.table_element);
        const last_ROW_NUM_str = String(last_row_number + 1);
        last_row_element.id = row_id_str;
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(last_row_number, 0, Elcon.textContent, last_ROW_NUM_str);
        CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V2(last_row_number, CMU_Bus105_FID.IFB_RELOAD_RECORD, Elcon.innerHTML, REC.IFB_RELOAD_RECORD_as_str);
        CMU_Bus105.CMU_Bus105_POPULATE_ROW(last_row_number, REC);
        CMU_Bus105.CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW();
        CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW = last_row_number;
        CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN = 0; // column of ROW_NUM
        CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
        CMU_Bus105.CMU_Bus105_SCROLL_TO_CELL_INA();
    }


    public static CMU_Bus105_REFRESH_SITE(): void {
        cmux_refresh_site();
    }


    public static async CMU_Bus105_COM_PostField(p_record_code: number, p_field_name_str: string, p_field_value_str: string, location: TABLE_Location): Promise<void> {
        debugger;
        // FetchExt() להזכירך: בנוגע לפונקציות מסוג "שגר ושכח" אין צורך וגם בלתי אפשרי להשתמש ב
        // FetchExt() להזכירך: בנוגע לפונקציות מסוג "שגר ושכח" אין צורך וגם בלתי אפשרי להשתמש ב
        // FetchExt() להזכירך: בנוגע לפונקציות מסוג "שגר ושכח" אין צורך וגם בלתי אפשרי להשתמש ב
        const info: VECTOR_Info = new VECTOR_Info(p_field_name_str, p_field_value_str, location.row, location.column);
        const token = UTL.ASP_GetAntiForgeryToken();
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        const row_number = CMU_Bus105.CMU_Bus105_trans_reocrd_code_to_row_number(p_record_code);
        const obj: CdFnCntPayload = new CdFnCntPayload();
        obj.record_code_as_str = p_record_code.toString();
        obj.field_name_str = p_field_name_str;
        obj.field_content_str = p_field_value_str;
        const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
        fetch_options.method = "POST";
        fetch_options.headers = { 'Content-Type': 'application/json', 'RequestVerificationToken': token };
        fetch_options.body = JSON.stringify(obj);
        const url = `/cmux/cmux_bus105?handler=PostField&record_code=${p_record_code}`;  // record_code שים לב שאין באמת שימוש ב
        VECTOR.Send(url, fetch_options, info, CMU_Bus105.CMU_Bus105_vector_update_function);
    }





    public static async CMU_Bus105_Keys_Insert(): Promise<void> {
        const row_number = CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW;
        const fid = CMU_Bus105.CMU_Bus105_trans_column_number_to_fid(CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN);
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        const location: TABLE_Location = new TABLE_Location(CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW, CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN);
        const record_code = CMU_Bus105.CMU_Bus105_trans_row_number_to_record_code(CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW);
        const cell_element = CMU_Bus105.CMU_Bus105_GET_CELL_ELEMENT_V1(CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW, CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN);
        //======================================
        // added vars for GSP.InputDialogAsync()
        //--------------------------------------
        const column_number = CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN;
        let field_name_str = TRANS.quick_trans_enum_object_and_number_to_string(CMU_Bus105_FID, fid);
        //======================================



        if (fid == CMU_Bus105_FID.ROW_NUM) {
            await DLG.HPromptfAsync("לא ניתן לבצע שינוי בעמודת הספרור");
        }
        if (fid == CMU_Bus105_FID.RECORD_CODE) {
            await DLG.HPromptfAsync("לא ניתן לשנות את קוד הרשומה ממסך זה");
        }
        if (fid == CMU_Bus105_FID.REC_ORG_CODE) {
            await DLG.HPromptfAsync("לא ניתן לשנות את קוד הארגון ממסך זה");
        }
        if (fid == CMU_Bus105_FID.REC_USERNAME) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_PASSWORD) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_FIRSTNAME) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;        
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_LASTNAME) {  
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;        
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_TAARIH_HITSTARFUT) {
            const OBJ: oDaton = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oDaton) as oDaton;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_UNIVERSAL_NAME_HE) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_UNIVERSAL_NAME_EN) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_UNIVERSAL_NAME_RU) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }



        if (fid == CMU_Bus105_FID.REC_ADDRESS) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;        
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_PHONE_NUMBER) {  
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_EMAIL) {
            const OBJ: oText = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oText) as oText;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_IS_ACTIVE) {
            const OBJ: oBool = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oBool) as oBool;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_REMARK) {  
            const OBJ: oMemo = TRANS.trans_cell_text_content_and_ilk_to_oVar_OBJ(cell_element.textContent, Ilk.oMemo) as oMemo;
            const changed = await GSP.InputDialogAsync(OBJ, Whisper.DEFAULT);
            if (changed == true) {
                const cell_str = OBJ.GetStrForTableCell_v1();
                const xml_str = OBJ.GetStrForXml_v1();
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, cell_str);
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, xml_str, location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.IFB_RELOAD_RECORD) {  
            await DLG.HPromptfAsync("אם ברצונך לבצע טעינת רשומה יש לבצע זאת באמצעות לחיצה על הכפתור באמצעות העכבר");
        }
    }


    public static async CMU_Bus105_Keys_Delete(): Promise<void> {
        const fid = CMU_Bus105.CMU_Bus105_trans_column_number_to_fid(CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN);
        let field_name_str = TRANS.quick_trans_enum_object_and_number_to_string(CMU_Bus105_FID, fid);
        const location: TABLE_Location = new TABLE_Location(CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW, CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN);
        const record_code = CMU_Bus105.CMU_Bus105_trans_row_number_to_record_code(CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW);
        const row_number = CMU_Bus105.CMU_Bus105_trans_reocrd_code_to_row_number(record_code);
        const column_number = CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN;


        if (fid == CMU_Bus105_FID.ROW_NUM) {
            await DLG.HPromptfAsync("לא ניתן לבצע שינוי בעמודת הספרור");
        }
        if (fid == CMU_Bus105_FID.RECORD_CODE) {
            await DLG.HPromptfAsync("לא ניתן לשנות את קוד הרשומה ממסך זה");
        }
        if (fid == CMU_Bus105_FID.REC_ORG_CODE) {
            await DLG.HPromptfAsync("לא ניתן לשנות את קוד הארגון ממסך זה");
        }
        if (fid == CMU_Bus105_FID.REC_USERNAME) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_PASSWORD) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_FIRSTNAME) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_LASTNAME) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_TAARIH_HITSTARFUT) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_UNIVERSAL_NAME_HE) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_UNIVERSAL_NAME_EN) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_UNIVERSAL_NAME_RU) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }





        if (fid == CMU_Bus105_FID.REC_ADDRESS) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_PHONE_NUMBER) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_EMAIL) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_IS_ACTIVE) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
        if (fid == CMU_Bus105_FID.REC_REMARK) {
            const confirmed = await DLG.HConfirmAsync("האם אתה בטוח שברצונך לבצע את המחיקה?");
            if (confirmed == true) {
                CMU_Bus105.CMU_Bus105_PUT_CELL_CONTENT_V1(row_number, column_number, Elcon.textContent, "");
                CMU_Bus105.CMU_Bus105_COM_PostField(record_code, field_name_str, "", location); //fire-and-forget
            }
        }
    }



    //LLLLLL
    public static CMU_Bus105_ADD_MARK_TO_CURRENT_ROW(): void {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        TABLE_CELL_MARKER_UTILITIES.PAINT_ROW(table_obj.table_element, CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW, "yellow", "black");
        TABLE_CELL_MARKER_UTILITIES.PAINT_CELL_GIVEN_ROW_AND_COLUMN(table_obj.table_element, CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW, CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN, "lightgreen", "black");
    }

    public static CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW(): void {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        TABLE_CELL_MARKER_UTILITIES.RESTORE_ROW(table_obj.table_element, CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW);

    }


    public static CMU_Bus105_ADJ_UP(): void {
        if (CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW > 0) {
            CMU_Bus105.CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW();
            CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW -= 1;
            CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
            CMU_Bus105.CMU_Bus105_SCROLL_TO_CELL_INA();
        }
    }




    public static CMU_Bus105_ADJ_DOWN(): void {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        const number_of_rows = TABLE.trans_table_element_to_number_of_rows(table_obj.table_element) 
        if (CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW < (number_of_rows -1)) {
            CMU_Bus105.CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW();
            CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW += 1;
            CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
            CMU_Bus105.CMU_Bus105_SCROLL_TO_CELL_INA();
        }
    }

    public static CMU_Bus105_ADJ_LEFT(): void {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();    
        //const number_of_columns = TABLE.trans_table_element_to_number_of_columns(table_obj.table_element);
        const number_of_columns = TABLE_CELL_MARKER_UTILITIES.CALC_NUMBER_OF_VISIBLE_COLUMNS_IN_ROW(table_obj.table_element, CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW);
        if (CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN < (number_of_columns - 1)) {
            CMU_Bus105.CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW();
            CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN += 1;
            CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
            CMU_Bus105.CMU_Bus105_SCROLL_TO_CELL_INA();
        }
    }

    public static CMU_Bus105_ADJ_RIGHT(): void {
        if (CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN > 0) {
            CMU_Bus105.CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW();
            CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN -= 1;
            CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
            CMU_Bus105.CMU_Bus105_SCROLL_TO_CELL_INA();
        }
    }


    public static CMU_Bus105_ADJ_NEXT(): void {
        for (let i=0; i < 20; i++) {
            CMU_Bus105.CMU_Bus105_ADJ_UP();
        }
    }

    public static CMU_Bus105_ADJ_PRIOR(): void {
        for (let i=0; i < 20; i++) {
            CMU_Bus105.CMU_Bus105_ADJ_DOWN();
        }
    }


    public static CMU_Bus105_ADJ_HOME(): void {
        CMU_Bus105.CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW();
        CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN = 0;
        CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
        CMU_Bus105.CMU_Bus105_SCROLL_TO_CELL_INA();
    }

    public static CMU_Bus105_ADJ_CONTROL_HOME(): void {
        CMU_Bus105.CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW();
        CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW = 0;
        CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN = 0;
        CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
        CMU_Bus105.CMU_Bus105_SCROLL_TO_CELL_INA();
    }

    public static CMU_Bus105_ADJ_END(): void {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();    
        const number_of_columns = TABLE.trans_table_element_to_number_of_columns(table_obj.table_element);
        CMU_Bus105.CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW();
        const last_col = (number_of_columns - 1);
        CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN = last_col;
        CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
        CMU_Bus105.CMU_Bus105_SCROLL_TO_CELL_INA();
    }

    public static CMU_Bus105_ADJ_CONTROL_END(): void {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();    
        const number_of_rows = TABLE.trans_table_element_to_number_of_rows(table_obj.table_element) 
        const number_of_columns = TABLE.trans_table_element_to_number_of_columns(table_obj.table_element);
    
        CMU_Bus105.CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW();
        CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW = (number_of_rows - 1);

        if (false) {
            const last_col = (number_of_columns - 1);
            CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN = last_col;
        }
        if (true) {
            // מעדיפים את זה ככה
            const first_col = 0;
            CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN = first_col;
        }



        CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
        CMU_Bus105.CMU_Bus105_SCROLL_TO_CELL_INA();
    }





    public static CMU_Bus105_keydown_event_should_preventDefault(event: KeyboardEvent): boolean {
       if (event.key === 'Escape') return true;
       if (event.key === 'Insert') return true;
       if (event.key === 'Delete') return true;
       if (event.key === 'ArrowUp') return true;
       if (event.key === 'ArrowDown') return true;
       if (event.key === 'ArrowLeft') return true;
       if (event.key === 'ArrowRight') return true;
       if (event.key === 'PageUp') return true;
       if (event.key === 'PageDown') return true;
       if (event.key === 'Home') return true;
       if (event.key === 'End') return true;
       if (event.key === 'F1') return true;
       if (event.key === 'F2') return true;
       if (event.key === 'F3') return true;
       if (event.key === 'F6') return true;
       //------------------------------------
       return false;
    }




    public static async CMU_Bus105_keydown(event: KeyboardEvent): Promise<void> {
        if (UTL.modal_is_opened == true || UTL.block_everything == true) {
            return;
        }


        if (CMU_Bus105.CMU_Bus105_keydown_event_should_preventDefault(event) == true)
        {
            event.preventDefault(); // Prevents the default help dialog
        }




        if (event.key === 'Insert') {
            //event.preventDefault(); // Prevents the default help dialog
            await CMU_Bus105.CMU_Bus105_Keys_Insert();
        }

        if (event.key === 'Delete') {
            //event.preventDefault(); // Prevents the default help dialog
            await CMU_Bus105.CMU_Bus105_Keys_Delete();
        }

        if (event.key === 'F2') {
            //event.preventDefault(); // Prevents the default help dialog
            await CMU_Bus105.CMU_Bus105_Keys_Insert();
        }
        if (event.key === 'F3') {
            //event.preventDefault(); // Prevents the default help dialog
            CMU_Bus105.CMU_Bus105_perform_F3();
        }
        if (event.key === 'F1') {
            //event.preventDefault(); // Prevents the default help dialog
            alert("F1 ready to use")
        }
        if (event.key === 'F6') {
            //event.preventDefault(); // Prevents the default help dialog
            await CMU_Bus105.CMU_Bus105_PERFORM_APPEND_RECORD();
        }

        if (event.key === 'Enter') {
            //centerModal();               
        }
        if (event.key === 'Escape') {
            //event.preventDefault(); // <-- this disables the default behavior
            // פתוח או לא. בשלב זה תמיד סוגרים. בהמשך עדיף לבצא בדיקה Modal בשלב זה אנחנו לא בודקים האם ה
            // פתוח או לא. בשלב זה תמיד סוגרים. בהמשך עדיף לבצא בדיקה Modal בשלב זה אנחנו לא בודקים האם ה
            // פתוח או לא. בשלב זה תמיד סוגרים. בהמשך עדיף לבצא בדיקה Modal בשלב זה אנחנו לא בודקים האם ה
            //hideModal();
        }
        if (event.key === 'ArrowUp') {
            //event.preventDefault(); // <-- this disables the default behavior
            CMU_Bus105.CMU_Bus105_ADJ_UP();
        }
        if (event.key === 'ArrowDown') {
            //event.preventDefault(); // <-- this disables the default behavior
            CMU_Bus105.CMU_Bus105_ADJ_DOWN();
        }
        if (event.key === 'ArrowLeft') {
            //event.preventDefault(); // <-- this disables the default behavior
            CMU_Bus105.CMU_Bus105_ADJ_LEFT();
        }
        if (event.key === 'ArrowRight') {
            //event.preventDefault(); // <-- this disables the default behavior
            CMU_Bus105.CMU_Bus105_ADJ_RIGHT();
        }
        if (event.key === 'PageUp') {
            //event.preventDefault(); // <-- this disables the default behavior
            CMU_Bus105.CMU_Bus105_ADJ_NEXT();
        }
        if (event.key === 'PageDown') {
            //event.preventDefault(); // <-- this disables the default behavior
            CMU_Bus105.CMU_Bus105_ADJ_PRIOR();
        }
        if (event.key === 'Home') {
            //event.preventDefault(); // <-- this disables the default behavior
            if (event.ctrlKey == false) CMU_Bus105.CMU_Bus105_ADJ_HOME();
            if (event.ctrlKey == true) CMU_Bus105.CMU_Bus105_ADJ_CONTROL_HOME();
        }
        if (event.key === 'End') {
            //event.preventDefault(); // <-- this disables the default behavior
            if (event.ctrlKey == false) CMU_Bus105.CMU_Bus105_ADJ_END();
            if (event.ctrlKey == true) CMU_Bus105.CMU_Bus105_ADJ_CONTROL_END();
        }
    }







    public static CMU_Bus105_create_table_object(): TableObject {
        const table_obj: TableObject = new TableObject();
        table_obj.table_element = document.getElementById("id-table") as HTMLTableElement;
        table_obj.taco_element = document.getElementById("id-taco");
        table_obj.has_vertical_scroll = true;
        table_obj.has_horizontal_scroll = true;
        table_obj.exist_head = true;
        table_obj.exist_numerator = false;
        table_obj.direction = "rtl";
        return table_obj;
    
    }


    public static CMU_Bus105_SCROLL_TO_CELL_INA(): void {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        TBLSCROLLER.scroll_to_cell_INA(table_obj, CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW, CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN);
    }



    public static CMU_Bus105_TABLE_mousedown(event: MouseEvent): void {
        if (UTL.block_everything == true) {
            return;
        }
        const target_element = event.target as HTMLElement;
        const row_number = TABLE.trans_mouse_target_to_row_number(target_element);
        const column_number = TABLE.trans_mouse_target_to_column_number(target_element);
        if (row_number != (-1) && column_number != (-1)) {
            if (true) {
                CMU_Bus105.CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW();
                CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW = row_number;
                CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN = column_number;
                CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
            }
        }        
    }






    public static CMU_Bus105_test_dialog500(): void {
        const xx = "Error in send_field_to_server:\n\n\n\n error=TypeError: Failed to fetch record_code_as_str=169 field_name_str=REC_FIRSTNAME field_content_str=1234123qwerqwe";
        DIALOG500.create_dialog(xx);
    }


    public static CMU_Bus105_FORMAT1(): void {
        debugger;
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        const fids: string[] = ["ROW_NUM", "RECORD_CODE", "REC_ORG_CODE", "REC_USERNAME", "REC_PASSWORD", "REC_FIRSTNAME", "REC_LASTNAME", "REC_TAARIH_HITSTARFUT", "REC_UNIVERSAL_NAME_HE", "REC_UNIVERSAL_NAME_EN", "REC_UNIVERSAL_NAME_RU", "REC_ADDRESS", "REC_PHONE_NUMBER", "REC_EMAIL", "REC_IS_ACTIVE", "REC_REMARK", "IFB_RELOAD_RECORD"];
        TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.reorder_columns_in_table_element_by_fids_given_partial_list_of_fids(table_obj.table_element, fids);
    }

    public static CMU_Bus105_FORMAT2(): void {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        const fids: string[] = ["ROW_NUM", "REC_FIRSTNAME", "REC_LASTNAME", "REC_TAARIH_HITSTARFUT", "IFB_RELOAD_RECORD"];
        TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.reorder_columns_in_table_element_by_fids_given_partial_list_of_fids(table_obj.table_element, fids);
    }

    public static CMU_Bus105_FORMAT3(): void {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        const fids: string[] = ["ROW_NUM", "REC_USERNAME", "REC_PASSWORD", "IFB_RELOAD_RECORD"];
        TABLE_FORMAT_COLUMNS_AUX_FUNCTIONS.reorder_columns_in_table_element_by_fids_given_partial_list_of_fids(table_obj.table_element, fids);
    }

    public static CMU_Bus105_TEST1(): void {
        //alert("CMU_Bus105_TEST1() a");
        const elements: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName("cl-th-db-column") as HTMLCollectionOf<HTMLElement>;
        for (let i = 0; i < elements.length; i++) {
            elements[i].style.display = "none";
        }
        DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-column", false);
        //alert("b");
    }


    public static CMU_Bus105_logicChanged(element: HTMLInputElement): void {
        //alert("CMU_Bus105_logicChanged " + element.id);
        debugger;
        if (element.id == "id-head-description") {
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-column", false);
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-description", true);
        }
        if (element.id == "id-head-dbcolumns") {
            debugger;
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-column", true);
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-description", false);
        }
        if (element.id == "id-head-both") {
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-column", true);
            DOM_AUX_FUNCTIONS.show_or_hide_elements_by_class("cl-th-db-description", true);
        }
    }


    public static CMU_Bus105_respond_button_APPEND_RECORD(): void {
        CMU_Bus105.CMU_Bus105_PERFORM_APPEND_RECORD();
    }


    public static CMU_Bus105_myload(): void {
        const table_obj = CMU_Bus105.CMU_Bus105_create_table_object();
        table_obj.table_element.addEventListener('mousedown', CMU_Bus105.CMU_Bus105_TABLE_mousedown);
        document.addEventListener('keydown', CMU_Bus105.CMU_Bus105_keydown);
        CMU_Bus105.CMU_Bus105_VAR_CURRENT_ROW = 0;
        CMU_Bus105.CMU_Bus105_VAR_CURRENT_COLUMN = 0;
        CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
        CMU_Bus105.CMU_Bus105_SCROLL_TO_CELL_INA();
        //paint_citem(4)
    }






    public static CMU_Bus105_VAR_SORT_columnIndex: number = (-1);
    public static CMU_Bus105_VAR_SORT_last_sort_column: number = (-1);
    public static CMU_Bus105_VAR_SORT_sort_ascending_flag: boolean = true;


    public static CMU_Bus105_compare_strings_by_column(p_str1: string, p_str2: string): number {
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם
        // SMART_CMP להזכירך שבתאריך 16-10-26 אנחנו יוצרים מחלקה בשם

        const fid = CMU_Bus105.CMU_Bus105_trans_column_number_to_fid(CMU_Bus105.CMU_Bus105_VAR_SORT_columnIndex);
        //alert(`p_columnIndex=${p_columnIndex} fid=${fid}`);
        if (fid == CMU_Bus105_FID.ROW_NUM) {
            return CMP.compare_numbers_as_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.RECORD_CODE) {
            return CMP.compare_numbers_as_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_ORG_CODE) {
            return CMP.compare_numbers_as_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_USERNAME) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_PASSWORD) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_FIRSTNAME) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_LASTNAME) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_TAARIH_HITSTARFUT) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_UNIVERSAL_NAME_HE) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_UNIVERSAL_NAME_EN) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_UNIVERSAL_NAME_RU) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_ADDRESS) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_PHONE_NUMBER) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_EMAIL) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_IS_ACTIVE) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.REC_REMARK) {
            return CMP.compare_strings(p_str1, p_str2, false);
        }
        if (fid == CMU_Bus105_FID.IFB_RELOAD_RECORD) {

        }
        return 0;
    }



    public static CMU_Bus105_compare_table_rows_by_column(row_element1: HTMLTableRowElement, row_element2: HTMLTableRowElement): number {

        const text1: string = row_element1.cells[CMU_Bus105.CMU_Bus105_VAR_SORT_columnIndex].innerText;
        const text2: string = row_element2.cells[CMU_Bus105.CMU_Bus105_VAR_SORT_columnIndex].innerText;
        const diff: number = CMU_Bus105.CMU_Bus105_compare_strings_by_column(text1, text2);
        if (CMU_Bus105.CMU_Bus105_VAR_SORT_sort_ascending_flag == true) {
            return diff;
        }
        else {
            return -diff;
        }
    }


    public static CMU_Bus105_init_all_sort_icons(): void {
        const allHeaders: NodeListOf<HTMLTableCellElement> = document.querySelectorAll("th");
        for (let i: number = 0; i < allHeaders.length; i++) {
            const header: HTMLTableCellElement = allHeaders[i];
            const icon: HTMLElement = header.querySelector(".cl-th-sort-element");
            if (icon !== null) {
                icon.innerHTML = "↕";
            }
        }
    }


    public static CMU_Bus105_updateSortIcon(th: HTMLTableCellElement, is_ascending: boolean): void {
        CMU_Bus105.CMU_Bus105_init_all_sort_icons();
        const icon: HTMLElement = th.querySelector(".cl-th-sort-element");
        if (icon !== null) {
            if (is_ascending == true) {
                // icon.innerHTML = "↑";
                icon.innerHTML = "▲";
            }
            else {
                // icon.innerHTML = "↓";
                icon.innerHTML = "▼";
            }
        }
    }



    public static CMU_Bus105_sort_table_given_th_element(th_element: HTMLTableCellElement): void {
        debugger;
        CMU_Bus105.CMU_Bus105_REMOVE_MARK_FROM_CURRENT_ROW();
        const columnIndex: number = th_element.cellIndex;
        CMU_Bus105.CMU_Bus105_VAR_SORT_columnIndex = columnIndex;
        const table_element: HTMLTableElement = document.getElementById("id-table") as HTMLTableElement;
        if (table_element === null) {
            throw new Error("Table element not found");
        }
        th_element.dataset.sortDirection = "desc";
        if (CMU_Bus105.CMU_Bus105_VAR_SORT_last_sort_column === columnIndex) {
            CMU_Bus105.CMU_Bus105_VAR_SORT_sort_ascending_flag = !CMU_Bus105.CMU_Bus105_VAR_SORT_sort_ascending_flag;
        }
        else {
            CMU_Bus105.CMU_Bus105_VAR_SORT_last_sort_column = columnIndex;
            CMU_Bus105.CMU_Bus105_VAR_SORT_sort_ascending_flag = true;
        }
        CMU_Bus105.CMU_Bus105_updateSortIcon(th_element, CMU_Bus105.CMU_Bus105_VAR_SORT_sort_ascending_flag);
        TABLE_SORT_ROWS_AUX_FUNCTIONS.sortTable(table_element, CMU_Bus105.CMU_Bus105_compare_table_rows_by_column);
        CMU_Bus105.CMU_Bus105_ADD_MARK_TO_CURRENT_ROW();
    }
}

export const CMU_Bus105_wrapper = {
    // export הוא להוות אובייקט למטרת wrapper המטרה של ה
    // export הוא להוות אובייקט למטרת wrapper המטרה של ה
    // export הוא להוות אובייקט למטרת wrapper המטרה של ה
    CMU_Bus105_myload: CMU_Bus105.CMU_Bus105_myload,
    CMU_Bus105_Keys_Insert: CMU_Bus105.CMU_Bus105_Keys_Insert,
    CMU_Bus105_respond_button_APPEND_RECORD: CMU_Bus105.CMU_Bus105_respond_button_APPEND_RECORD,
    CMU_Bus105_respond_button_reload_record: CMU_Bus105.CMU_Bus105_respond_button_reload_record,
    CMU_Bus105_test_dialog500: CMU_Bus105.CMU_Bus105_test_dialog500,
    CMU_Bus105_sort_table_given_th_element: CMU_Bus105.CMU_Bus105_sort_table_given_th_element,
    CMU_Bus105_FORMAT1: CMU_Bus105.CMU_Bus105_FORMAT1,
    CMU_Bus105_FORMAT2: CMU_Bus105.CMU_Bus105_FORMAT2,
    CMU_Bus105_FORMAT3: CMU_Bus105.CMU_Bus105_FORMAT3,
    CMU_Bus105_TEST1: CMU_Bus105.CMU_Bus105_TEST1,
    CMU_Bus105_logicChanged: CMU_Bus105.CMU_Bus105_logicChanged
};

if (false) {
    // cshtml ולכן אנחנו מעבירים אותם לקובץ ה vite להזכיך שהפעולות בבלוק זה עשו לנו בעיות במעבר ל
    // cshtml ולכן אנחנו מעבירים אותם לקובץ ה vite להזכיך שהפעולות בבלוק זה עשו לנו בעיות במעבר ל
    // cshtml ולכן אנחנו מעבירים אותם לקובץ ה vite להזכיך שהפעולות בבלוק זה עשו לנו בעיות במעבר ל
    window.onload = CMU_Bus105.CMU_Bus105_myload;
}


